import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'selectWrapper', 'select']

  connect () {
    this.update()
  }

  update () {
    const linked = this.checkboxTarget.checked

    this.selectWrapperTarget.classList.toggle('hidden', !linked)

    if (!linked) {
      this.selectTarget.value = ''
    }
  }
}
